import { render, staticRenderFns } from "./careerPlanning.vue?vue&type=template&id=f386b9b2&scoped=true"
import script from "./careerPlanning.vue?vue&type=script&lang=js"
export * from "./careerPlanning.vue?vue&type=script&lang=js"
import style0 from "./careerPlanning.vue?vue&type=style&index=0&id=f386b9b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f386b9b2",
  null
  
)

export default component.exports